
import { Box } from '@chakra-ui/react';
import './App.css';
import About from './Components/About';
import Contact from './Components/Contact';
import Github from './Components/Github';
import Home from './Components/Home';
import Navbar from './Components/Navbar';
import Projects from './Components/Projects';
import Skills from './Components/Skills';
import { useEffect, useState } from 'react';
import Loader from './Components/Loader';
function App() {
  let [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 500)

  }, [])
  return (
    <>
      {loading ? <Loader /> :
        (<>
          <Box maxW={"100vw"}>
            <Navbar />
            <Box maxWidth={{ base: "100vw", lg: "90vw" }} margin="auto">
              <Home />
              <About />
              <Skills />
              <Projects />
              <Github />
            </Box>
            <Contact />
          </Box>
        </>)
      }
    </>
  );
}

export default App;
